import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'show-secret-toggle',
  templateUrl: './show-secret-toggle.component.html',
})
export class ShowSecretToggleComponent {
  private _isHidden: boolean;

  public get isHidden(): boolean {
    return this._isHidden;
  }

  @Input()
  public label: string;

  @Input()
  public tabindex: number;

  @Input()
  public iconClass: string;

  @Input()
  public dataTestID: string;

  @Output()
  public isHiddenChanged = new EventEmitter<boolean>();

  constructor() {
    this.setIsHiddenAndRaiseEvent(true);
  }

  public invertVisibility(event: Event): void {
    event.preventDefault();
    this.setIsHiddenAndRaiseEvent(!this._isHidden);
  }

  public getLabel(): string {
    if (!this.label) {
      return '';
    }

    return this.isHidden ? `${this.label}, hidden` : `${this.label}, visible`;
  }

  private setIsHiddenAndRaiseEvent(value: boolean): void {
    if (value === this._isHidden) {
      return;
    }

    this._isHidden = value;
    this.isHiddenChanged.emit(value);
  }
}
